import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateTaskItemRequest, TaskItem, UpdateTaskItemRequest } from './task-item.model';

/**
 * Service for managing checklist items that belong to a task.
 *
 * @author sadatmalik
 */
@Injectable({ providedIn: 'root' })
export class TaskItemService {
  private readonly http = inject(HttpClient);
  private readonly tasksBaseUrl = `${environment.apiBaseUrl}/api/tasks`;

  list(taskId: string): Observable<TaskItem[]> {
    return this.http.get<TaskItem[]>(`${this.tasksBaseUrl}/${taskId}/items`);
  }

  create(taskId: string, request: CreateTaskItemRequest): Observable<TaskItem> {
    return this.http.post<TaskItem>(`${this.tasksBaseUrl}/${taskId}/items`, request);
  }

  update(taskId: string, itemId: string, request: UpdateTaskItemRequest): Observable<TaskItem> {
    return this.http.patch<TaskItem>(`${this.tasksBaseUrl}/${taskId}/items/${itemId}`, request);
  }

  delete(taskId: string, itemId: string): Observable<void> {
    return this.http.delete<void>(`${this.tasksBaseUrl}/${taskId}/items/${itemId}`);
  }

  clearDone(taskId: string): Observable<void> {
    return this.http.post<void>(`${this.tasksBaseUrl}/${taskId}/items/clear-done`, {});
  }
}
